// eslint-disable-next-line import/prefer-default-export
export const EDIT_BID_SELECTION = 'EDIT_BID_SELECTION';
export const RESET_BID_SELECTION = 'RESET_BID_SELECTION';
export const UPDATE_SELECTION_FILTERS = 'UPDATE_SELECTION_FILTERS';
